import actions from "./metaActions";

const initialState = {
  nearbyParties: [],
  loading: false,
};

export const STATE_KEY = "meta";

const metaReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.START_NEARBY_PARTIES_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case actions.END_NEARBY_PARTIES_REQUEST:
      return {
        ...state,
        loading: false,
      };
    case actions.LOAD_NEARBY_PARTIES:
      return {
        ...state,
        nearbyParties: action.payload,
      };
    default:
      return state;
  }
};

export default metaReducer;
